import { IFeatureProps } from 'mod/featureV2/interface';
import { IFeatureSwiperReviews } from 'mod/featureV2/interface/swiperReviews';
import { FeatureSwiperReviews as ModFeatureSwiperReviews } from 'mod/featureV2/FeatureSwiperReviews';
import cn from 'classnames';
import swiperStyles from '@pro/feature/swiper.module.less';
import styles from './index.module.less';

export function FeatureSwiperReviews(props: IFeatureProps<IFeatureSwiperReviews>): Globals.JSXRenderType {
    return (
        <ModFeatureSwiperReviews
            className={cn(swiperStyles.scrollbar, styles['swiper-reviews'])}
            {...props}
        />
    )
}

export default FeatureSwiperReviews;